<ng-template #suffixIconTemplate>
  <svg-icon src="assets/icons/Time/calendar-date.svg" class="size-4" />
</ng-template>

<nz-range-picker
  class="w-full"
  [nzShowWeekNumber]="true"
  [nzSize]="props.size ?? 'default'"
  [nzPlaceHolder]="props.placeholder ?? ' -missing '"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [nzAllowClear]="false"
  [nzDisabled]="props.disabled"
  [nzDisabledDate]="disabledDate"
  [nzSuffixIcon]="suffixIconTemplate"
/>
